<template>
    <div class="services">
        <page-cover
            v-if="servicesPage.PageCover"
            :img="servicesPage.PageCover.Image?.url ?? ''"
            :title="servicesPage.PageCover.Title"
            :sub-title="servicesPage.PageCover.Subtitle"
        />
        <section v-if="servicesPage.BodyText">
            <div
                class="md:container mx-auto px-4 py-8 lg:px-12 md:py-12 lg:py-24"
            >
                <div class="lg:mx-32">
                    <div class="text-center">
                        <rich-text :text="servicesPage.BodyText.Description" />
                    </div>
                    <div
                        v-if="servicesPage.BodyText.ButtonUrl"
                        class="text-center mt-8"
                    >
                        <nuxt-link :to="servicesPage.BodyText.ButtonUrl"
                            ><button class="btn btn-primary btn-arrow">
                                {{ servicesPage.BodyText.ButtonText }}
                            </button></nuxt-link
                        >
                    </div>
                </div>
            </div>
        </section>
        <section v-if="servicesPage.Service">
            <div
                class="md:container mx-auto px-4 pb-8 lg:px-12 md:pb-12 lg:pb-24"
            >
                <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    <service-card
                        v-for="(s, i) in servicesPage.Service"
                        :key="i"
                        :icon-url="s.Icon?.url ?? ''"
                        :title="s.Title"
                        :description="s.Description"
                    />
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
const config = useRuntimeConfig();
const { data: servicesPage } = await useFetch(
    config.public.baseURl + '/services-page'
);

useHead({
    title: 'Services',
});
</script>

<style lang="scss" scoped>
.services {
}
</style>
